import utils from './index'
import { message } from 'ant-design-vue'
let reg = () => {
  return {
    tel: /^1[3|4|5|6|7|8|9][0-9]{9}$/, //手机号码校验
    telCode: /^\d{6}$/,
    max10: /^[0-9a-zA-Z\u4e00-\u9fa5]{1,10}$/, //限制1-10字数
    max6: /^([0-6])$/, //限制0-6数字
    number: /^[0-9]*$/, //只能输入数字
    number1: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/, //只能输入数字,带小数点
    minNumber0: /^[1-9]{1}[0-9]*$/, //大于0的数字
    price: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, //金额 最少为0
    chinese: /[\u4e00-\u9fa5]/, //汉字校验
    Email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, //  邮箱
    url: `/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(/.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+/.?/`, // 网站
    idCard: /^((\d{18})|([0-9x]{18})|([0-9X]{18}))$/, //  身份证
  }
}
let rule = {
  telCode: [
    {
      required: true,
      message: '验证码不能为空',
      trigger: 'blur',
    },
    {
      required: true,
      message: '请6位验证码',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!reg().telCode.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  password: [
    {
      required: true,
      message: '密码不能为空',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error(rule))
        } else {
          callback()
        }
      },
    },
  ],
  number: [
    {
      message: '只能输入数字',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback()
        } else if (!reg().number.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  number1: [
    {
      message: '只能输入数字',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback()
        } else if (!reg().number1.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  max6: [
    {
      message: '只能输入1-6的数字',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback()
        } else if (!reg().max6.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  price: [
    {
      message: '请输入正确的金额',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback()
        } else if (!reg().price.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  chinese: [
    {
      message: '真实姓名只能为汉字',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback()
        } else if (!reg().chinese.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  idCard: [
    {
      message: '请输入正确的身份证号',
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) {
          callback()
        } else if (!/^((\d{18})|([0-9x]{18})|([0-9X]{18}))$/.test(value)) {
          callback(new Error())
        } else {
          callback()
        }
      },
    },
  ],
  /**
   * 手机号
   * @returns {[{trigger: string, message: string, required: boolean}]}
   */
  phone: [
    {
      // required: true,
      trigger: 'change',
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(false, value, callback)
        result && (result = regMethod.phone(value, callback, '请输入正确的手机号'))
        result && callback()
      },
    },
  ],
  /**
   * 手机号
   * @returns {[{trigger: string, message: string, required: boolean}]}
   */
  otherPhone: [
    {
      // required: true,
      trigger: 'change',
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(false, value, callback)
        result && (result = regMethod.otherPhone(value, callback, '请输入正确的手机号'))
        result && callback()
      },
    },
  ],
}
/**
 * 校验方法汇总方法，始终返回是否通过校验 返回值为true false
 */
const regMethod = {
  /**
   * 必填
   * @param required 是否必填
   * @param value 校验值
   * @param callback 回调函数
   * @returns {boolean} 返回结果
   */
  required: (required, value, callback) => {
    if (required && utils.isEmpty(value)) {
      callback(new Error('这是必填项'))
      return false
    }
    return true
  },
  /**
   * 校验是否为特殊字符
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  checkSpecial: (value, callback, message = `不能输入特殊字符`) => {
    if (utils.isEmpty(value)) return true
    const pattern =
      /[^~!@#$%^&*()_\-+=<>?:"{}|,.\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\u4e00-\u9fa5A-Za-z0-9]/g
    if (eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 字段长度
   * @param required 是否必填
   * @param value 校验值
   * @param callback 回调函数
   * @returns {boolean} 返回结果
   */
  len: (value, callback, minLen, maxLen, message = `字段长度为${minLen + '-' + maxLen}`) => {
    if (utils.isEmpty(value)) return true
    if (minLen && maxLen) {
      if (Number(minLen) > String(value).length || Number(maxLen) < String(value).length) {
        callback(new Error(message))
        return false
      }
    } else if (minLen) {
      if (Number(minLen) > String(value).length) {
        callback(new Error(`字段最小长度为${minLen}`))
        return false
      }
    } else if (maxLen) {
      if (Number(maxLen) < String(value).length) {
        callback(new Error(`字段最大长度为${maxLen}`))
        return false
      }
    }
    return true
  },
  /**
   * 验证是否为金额
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  price: (value, callback, message = `请输入正确的金额`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/(^[1-9]([0-9]+)?(\\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\\.[0-9]([0-9])?$)/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 只能输入 *-* 之前的数字
   * @param value 校验值
   * @param callback 回调函数
   * @param minNum 最小值
   * @param maxNum 最大值
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  limitPrice: (value, callback, minNum = 1, maxNum = 1, message = `只能输入数字为${minNum + '-' + maxNum}的数字`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/(^[1-9]([0-9]+)?(\\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\\.[0-9]([0-9])?$)([${minNum}-${maxNum}])$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 验证是否为数字
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  number: (value, callback, message = `只能输入数字`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/^[0-9]*$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 最少数字为 *
   * @param value 校验值
   * @param callback 回调函数
   * @param num 最小值
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  minNumber: (value, callback, num = 1, message = `最小值为${num}的数字`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/^[1-9]{${num}}[0-9]*$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 只能输入 *-* 之前的数字
   * @param value 校验值
   * @param callback 回调函数
   * @param minNum 最小值
   * @param maxNum 最大值
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  limitNumber: (value, callback, minNum = 1, maxNum = 1, message = `只能输入数字为${minNum + '-' + maxNum}的数字`) => {
    if (utils.isEmpty(value)) return true
    if (!(Number(minNum) <= Number(value) && Number(value) <= Number(maxNum))) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 手机号校验
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  phone: (value, callback, message = `请输入正确的手机号`) => {
    if (utils.isEmpty(value)) return true
    // `/^[0-9\\/#*\\-]{20}$/`
    const pattern = `/^1[1|2|3|4|5|6|7|8|9][0-9]{9}$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 手机号校验
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  otherPhone: (value, callback, message = `请输入正确的手机号`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/^[0-9\\/#*\\-]{1,20}$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 数字和字母
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  englishAndNumber: (value, callback, message = `只能输入字母或数字`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/^[A-Za-z0-9]+$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 字母
   * @param value 校验值
   * @param callback 回调函数
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  english: (value, callback, message = `只能输入字母`) => {
    if (utils.isEmpty(value)) return true
    const pattern = `/^[A-Za-z]+$/`
    if (!eval(pattern).test(value)) {
      callback(new Error(message))
      return false
    }
    return true
  },
  /**
   * 只能输入长度为 *-* 的字母
   * @param value 校验值
   * @param callback 回调函数
   * @param minNum 最小值
   * @param maxNum 最大值
   * @param message 提示消息
   * @returns {boolean} 返回结果
   */
  limitEnglish: (value, callback, minLen, maxLen, message = `只能输入长度为${minLen + '-' + maxLen}的字母`) => {
    if (utils.isEmpty(value)) return true
    if (!(Number(minLen) <= Number(value) && Number(value) <= Number(maxLen))) {
      callback(new Error(message))
      return false
    } else if (minLen) {
      if (Number(minLen) > String(value).length) {
        callback(new Error(`字段最小长度为${minLen}`))
        return false
      }
    } else if (maxLen) {
      if (Number(maxLen) < String(value).length) {
        callback(new Error(`字段最大长度为${maxLen}`))
        return false
      }
    }
    return true
  },
}

/**
 * 必填
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const required = ({
  required = true,
  type = 'string',
  trigger = 'change',
  message = '这是必填项',
  checkSpecial = false,
}) => {
  return [
    {
      type: type,
      required: required,
      message: message,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && callback()
      },
    },
  ]
}
/**
 * 必填
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const requiredArr = ({
  required = true,
  type = 'Array',
  trigger = 'change',
  message = '这是必填项',
  checkSpecial = false,
}) => {
  return [
    {
      type: type,
      required: required,
      message: message,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && callback()
      },
    },
  ]
}
/**
 * 正确的金额
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const price = ({ required = false, trigger = 'change', message = '请输入正确的金额' }) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.price(value, callback, message))
        result && callback()
      },
    },
  ]
}
/**
 * 正确的金额
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const limitPrice = ({
  required = false,
  trigger = 'change',
  minNum = 1,
  maxNum = 999999.99,
  message = `只能输入金额为${minNum + '-' + maxNum}的价格`,
}) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.price(value, callback, message))
        result && (result = regMethod.limitNumber(value, callback, minNum, maxNum, message))
        result && callback()
      },
    },
  ]
}
/**
 * 数字+字母
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const englishAndNumber = ({ required = false, trigger = 'change', message = '只能输入字母或数字' }) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.englishAndNumber(value, callback, message))
        result && callback()
      },
    },
  ]
}
/**
 * 长度为 *-* 的字母
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const limitEnglish = ({
  required = false,
  trigger = 'change',
  minLen = 1,
  maxLen = 999,
  message = '只能输入字母',
}) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.limitEnglish(value, callback, minLen, maxLen, message))
        result && callback()
      },
    },
  ]
}
/**
 * 手机号
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const phone = ({ required = false, trigger = 'change', message = '请输入正确的手机号' }) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.phone(value, callback, message))
        result && callback()
      },
    },
  ]
}
/**
 * 手机号
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const otherPhone = ({ required = false, trigger = 'change', message = '请输入正确的手机号' }) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.otherPhone(value, callback, message))
        result && callback()
      },
    },
  ]
}

// 验证手机号
export function validatePhone(value) {
  if (!(value && value.trim())) {
    message.warning('手机号不能为空')
    return false
  }
  if (!/^1\d{10}$/.test(value.trim())) {
    message.warning('手机号格式有误')
    return false
  }
  return true
}
/**
 * 只能输入数字
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const number = ({ required = false, trigger = 'change', message = '只能输入数字' }) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.number(value, callback, message))
        result && callback()
      },
    },
  ]
}
/**
 * 最小值为 * 的数字
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const minNumber = ({ required = false, trigger = 'change', num = 1, message = `最小值为${num}的数字` }) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.number(value, callback))
        result && (result = regMethod.minNumber(value, callback, num, message))
        result && callback()
      },
    },
  ]
}
/**
 * 只能是 *-* 之前的数字
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const limitNumber = ({
  required = false,
  trigger = 'change',
  minNum = 1,
  maxNum = 10,
  message = `只能输入数字为${minNum + '-' + maxNum}的数字`,
}) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && (result = regMethod.number(value, callback))
        result && (result = regMethod.limitNumber(value, callback, minNum, maxNum, message))
        result && callback()
      },
    },
  ]
}
/**
 * 长度为 *-* 支持只输入一个值 取最大或最小值
 * @returns {[{trigger: string, message: string, required: boolean}]}
 */
export const len = ({
  required = false,
  trigger = 'change',
  minLen,
  maxLen,
  checkSpecial,
  message = `字段长度为${minLen + '-' + maxLen}`,
}) => {
  return [
    {
      required: required,
      trigger: trigger,
      validator: (rule, value, callback) => {
        let result
        result = regMethod.required(required, value, callback)
        result && checkSpecial && (result = regMethod.checkSpecial(value, callback))
        result && (result = regMethod.len(value, callback, minLen, maxLen, message))
        result && callback()
      },
    },
  ]
}
export default rule
